import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import api, { getErrorMessage } from '../api/client';
import PasswordInput from '../components/PasswordInput';
import { Spinner } from '../components/StateBlock';

const MIN_PASSWORD_LENGTH = 6;

const Register = () => {
  const navigate = useNavigate();
  const [nome, setNome] = useState('');
  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [confirmarSenha, setConfirmarSenha] = useState('');
  const [isPending, setIsPending] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const onSubmit = async (event) => {
    event.preventDefault();
    setErrorMessage('');

    if (senha.length < MIN_PASSWORD_LENGTH) {
      setErrorMessage(`A senha precisa ter pelo menos ${MIN_PASSWORD_LENGTH} caracteres.`);
      return;
    }

    if (senha !== confirmarSenha) {
      setErrorMessage('A senha e a confirmação não coincidem.');
      return;
    }

    setIsPending(true);

    try {
      await api.post('/users/register', { nome: nome.trim(), email: email.trim(), senha });
      navigate('/login', {
        replace: true,
        state: { successMessage: 'Conta criada com sucesso. Faça login para continuar.' },
      });
    } catch (error) {
      setErrorMessage(getErrorMessage(error, 'Não foi possível criar a conta.'));
    } finally {
      setIsPending(false);
    }
  };

  return (
    <div className="page">
      <div className="auth-layout">
        <section className="surface-card card-pad auth-side">
          <span className="eyebrow">Nova conta</span>
          <h1 className="page-title">Comece a organizar as compras hoje.</h1>
          <p className="section-copy">
            Em poucos passos você tem listas por categoria, controle de gastos e
            compartilhamento com quem faz mercado com você.
          </p>
          <ul className="checklist">
            <li>Listas para casa, trabalho ou compras recorrentes.</li>
            <li>Itens por unidade ou por peso, com preço por quilo.</li>
            <li>Mesma experiência no celular e no computador.</li>
          </ul>
        </section>

        <section className="surface-card card-pad auth-card">
          <div className="section-heading__text">
            <span className="eyebrow">Cadastro</span>
            <h2 className="section-subtitle">Criar conta</h2>
          </div>

          {errorMessage && (
            <p className="notice notice--error" role="alert">
              {errorMessage}
            </p>
          )}

          <form onSubmit={onSubmit} className="field-form">
            <div className="field">
              <label className="field-label" htmlFor="nome">
                Nome
              </label>
              <input
                id="nome"
                type="text"
                className="input"
                value={nome}
                onChange={(event) => setNome(event.target.value)}
                autoComplete="name"
                required
                autoFocus
              />
            </div>

            <div className="field">
              <label className="field-label" htmlFor="email">
                E-mail
              </label>
              <input
                id="email"
                type="email"
                className="input"
                value={email}
                onChange={(event) => setEmail(event.target.value)}
                autoComplete="email"
                inputMode="email"
                required
              />
            </div>

            <PasswordInput
              id="senha"
              label="Senha"
              value={senha}
              onChange={(event) => setSenha(event.target.value)}
              autoComplete="new-password"
              required
            />

            <PasswordInput
              id="confirmarSenha"
              label="Confirmar senha"
              value={confirmarSenha}
              onChange={(event) => setConfirmarSenha(event.target.value)}
              autoComplete="new-password"
              required
            />

            <button type="submit" className="btn btn--primary btn--block" disabled={isPending}>
              {isPending ? <Spinner label="Criando conta..." /> : 'Cadastrar'}
            </button>
          </form>

          <p className="auth-footer">
            Já tem uma conta?{' '}
            <Link to="/login" className="link-inline">
              Faça login
            </Link>
          </p>
        </section>
      </div>
    </div>
  );
};

export default Register;
